import { createContext } from 'react';
import type { GiveNowSessionStorage } from '../hooks';

type GiveNowContextType = GiveNowSessionStorage;

export const GiveNowContext = createContext<GiveNowContextType | undefined>(undefined);
